import { fetcher } from '@commenda/utils';
import { API_BASE_PATH } from './constants';

type TCreateServiceRequestFromWorkflowParams = (
  | { workflowLinkId: string; workflowTemplateId?: never }
  | { workflowTemplateId: string; workflowLinkId?: never }
) & {
  companyId: number;
  corporationId?: number;
  assignedBusinessEntityIds?: number[];
};

export const createServiceRequestFromWorkflow = async (
  params: TCreateServiceRequestFromWorkflowParams
): Promise<{ success: boolean; data?: { id: string } }> => {
  const response = await fetcher(
    `${API_BASE_PATH}/from-workflow`,
    {
      method: 'POST',
      body: params,
    },
    undefined
  );

  if (!response.ok) return { success: false };

  try {
    const responseData = (await response.json()) as { id?: string };
    if (responseData?.id) {
      return { success: true, data: { id: responseData.id } };
    }
  } catch (err) {
    console.error('Failed to parse service request response', err);
  }

  return { success: true };
};
